/* ANDREA / CASA FACILE — mobile CTA attention controller V15 */
(() => {
  'use strict';
  if (window.__AndreaCtaGlowV15) return;
  window.__AndreaCtaGlowV15 = true;
  const mobile = window.matchMedia('(max-width: 749px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const activeSelector = ['.ae-home-hero .ae-home__btn','.ae-home-hero .ae-home-quickbar a','.ae-pro-nav__item--hot','.ae-pro-nav__item--cert-main','.cf-home-actions__btn'].join(',');
  let observer = null;
  const prepare = (scope = document) => {
    scope.querySelectorAll(['.ae-top-conversion__call','.ae-top-conversion__whatsapp',activeSelector].join(',')).forEach((el) => el.classList.add('ae-v15-magnetic'));
  };
  const setupObserver = () => {
    if (observer) { observer.disconnect(); observer = null; }
    document.querySelectorAll(activeSelector).forEach((el) => el.classList.remove('is-ae-v15-inview'));
    if (!mobile.matches || reduced.matches || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => entry.target.classList.toggle('is-ae-v15-inview', entry.isIntersecting));
    }, { threshold:0.35, rootMargin:'-24% 0px -24% 0px' });
    document.querySelectorAll(activeSelector).forEach((el) => observer.observe(el));
  };
  document.addEventListener('pointerdown', (event) => {
    const el = event.target.closest('.ae-v15-magnetic');
    if (!el || reduced.matches) return;
    el.classList.remove('is-ae-v15-tap'); void el.offsetWidth; el.classList.add('is-ae-v15-tap');
    window.setTimeout(() => el.classList.remove('is-ae-v15-tap'), 360);
  }, { passive:true });
  const init = (scope = document) => { prepare(scope); setupObserver(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once:true }); else init();
  document.addEventListener('shopify:section:load', (event) => window.setTimeout(() => init(event.target), 60));
  mobile.addEventListener?.('change', setupObserver); reduced.addEventListener?.('change', setupObserver);
})();
